const STAFF_PENDING_LOGIN_KEY = "auravit_staff_pending_login";

export const setStaffPendingLogin = (payload) => {
  sessionStorage.setItem(
    STAFF_PENDING_LOGIN_KEY,
    JSON.stringify({
      ...payload,
      issuedAt: Date.now(),
    })
  );
};

export const getStaffPendingLogin = () => {
  try {
    const raw = sessionStorage.getItem(STAFF_PENDING_LOGIN_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.email || !data?.password) return null;
    return data;
  } catch {
    return null;
  }
};

export const clearStaffPendingLogin = () => {
  try {
    sessionStorage.removeItem(STAFF_PENDING_LOGIN_KEY);
  } catch {
    /* ignore */
  }
};
